var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Input',{attrs:{"fileList":_vm.fileList,"currentConstruction":_vm.currentConstruction},on:{"refresh":_vm.refreshFiles,"upload":_vm.doUploadS3}})}
var staticRenderFns = []

export { render, staticRenderFns }